export const ticketMessages = {
  create: 'Tạo mới phiếu',
  customerCode: 'Mã khách hàng',
  customerRequestPhoneNumber: 'Số điện thoại khách hàng',
  fromDate: 'Từ ngày',
  toDate: 'Đến ngày',
  notHaveTicket: 'Chưa có phiếu'
};
